import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { motion, useReducedMotion } from 'framer-motion';
import { RevealHeading } from '../components/motion';
import { colors } from '../theme';

const EMAIL = 'adrian@adrianchesnoiu.com';
const LINKEDIN = 'https://www.linkedin.com/in/adrian-mihai-chesnoiu-11a3578b/';

export default function Contact() {
  const reduce = useReducedMotion();

  return (
    <Box
      id="contact"
      sx={{
        backgroundColor: colors.gray,
        py: { xs: 14, md: 22 },
      }}
    >
      <Container>
        <Box
          component={motion.div}
          initial={reduce ? undefined : { opacity: 0 }}
          whileInView={reduce ? undefined : { opacity: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          sx={{ textAlign: 'center', maxWidth: 760, mx: 'auto' }}
        >
          <Typography variant="overline" sx={{ color: colors.blue, letterSpacing: '0.24em' }}>
            CONTACT
          </Typography>
          <RevealHeading
            variant="h2"
            sx={{ mt: 2 }}
            segments={[{ text: 'Let’s build something great.' }]}
          />
          <Typography variant="subtitle1" sx={{ color: colors.inkSoft, mt: 2, mb: 5 }}>
            Reach out for support, feedback, or a new project — I’d love to hear from you.
          </Typography>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<EmailRoundedIcon />}
              href={`mailto:${EMAIL}`}
            >
              {EMAIL}
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<LinkedInIcon />}
              href={LINKEDIN}
              target="_blank"
              rel="noopener"
              sx={{
                borderColor: colors.grayBorder,
                color: colors.ink,
                '&:hover': { borderColor: colors.ink, background: 'transparent' },
              }}
            >
              LinkedIn
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
